import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Dialog, {
  DialogContent,
  DialogTitle,
} from 'material-ui/Dialog';
import Close from 'material-ui-icons/Close';
import IconButton from 'material-ui/IconButton';
import Toolbar from 'material-ui/Toolbar';
import Button from 'material-ui/Button';
import ArrowBack from '../Icons/ArrowBack';

const double = 2;
export const styles = theme => ({
  root: {
    top: '60px',
    height: 'calc(100% - 60px)',
    overflowY: 'scroll',
    boxSizing: 'border-box',
    alignItems: 'flex-start',
  },

  paper: {
    overflowY: 'unset',
    background: "#F4F6F9",
    margin: 0,
  },

  contentContainer: {
    margin: theme.spacing.unit * double,
    overflowY: "initial",
    textAlign: "center",
    padding: "0px 24px 16px 24px",
  },

  button: {
    position: 'fixed',
    right: '17px',
    top: '17px',
    color: 'white',
  },

  gutters: {
    background: "#FFFFFF",
    fontSize: "15px",
    fontWeight: 700,
    boxShadow: '0px 1px 0px #00000029',
  },

  backButton: {
    margin: 0,
    height: '68px',
    width: '60px',
    minWidth: 'unset',
    borderRight: '1px solid #D8DBDF',
    fontSize: 13,
  },
});

/**
* Dialogs are overlaid modal paper based components with a backdrop.
*/
const DialogModal = (props) => {
  const {
    classes,
    children,
    onClose,
    title,
    goBack,
    ...other
  } = props;

  const {
    button,
    gutters,
    contentContainer,
    backButton,
    ...rest
  } = classes;

  const renderCloseBtn = () => {
    if (onClose) {
      return (
        <IconButton onClick={onClose} className={button}>
          <Close color="inherit" width='20' height='20' />
        </IconButton>
      )
    }
  }

  const renderDialogTitle = () => {
    let backBtn;
    if (goBack) {
      backBtn = (
        <Button
          className={backButton}
          onClick={goBack}
          color="default"
          aria-label="Back">
          <ArrowBack color="#71737B" width={20} height={20} />
        </Button>
      )
    }

    if (title) {
      return (
        <Toolbar classes={{ gutters: gutters }} style={{ paddingLeft: backBtn ? '0px' : '25px' }}>
          {backBtn}
          <DialogTitle className={classes.flex} style={{ padding: backBtn ? '22px 25px' : '0px' }} disableTypography>{title}</DialogTitle>
        </Toolbar>
      );
    }
  }

  return (
    <Dialog
      classes={rest}
      onBackdropClick={onClose}
      {...other}
    >
      {renderCloseBtn()}
      {renderDialogTitle()}
      <DialogContent className={contentContainer}>
        {children}
      </DialogContent>
    </Dialog>
  );
}

DialogModal.propTypes = {
  classes: PropTypes.object.isRequired,
  /**
  * when onClose is defined, display an cross IconButton on the upper right corner
  */
  onClose: PropTypes.func,
  /**
  * when title is defined, display title in DialogTitle
  */
  title: PropTypes.string,
  /**
  * when goBack is defined, display an goBack Button on the upper left corner
  */
  goBack: PropTypes.func,
  children: PropTypes.node,
}

export default withStyles(styles)(DialogModal);



// WEBPACK FOOTER //
// ./src/components/common/DialogModal.jsx